'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
import * as $j_mealorama$002e$002dStore$002dCart$002dItem from "./mealorama.-Store-Cart-Item.js";
var $p;
/** @constructor */
function $c_Lmealorama_StoreCartItem$() {
}
export { $c_Lmealorama_StoreCartItem$ as $c_Lmealorama_StoreCartItem$ };
$p = $c_Lmealorama_StoreCartItem$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_StoreCartItem$;
/** @constructor */
function $h_Lmealorama_StoreCartItem$() {
}
export { $h_Lmealorama_StoreCartItem$ as $h_Lmealorama_StoreCartItem$ };
$h_Lmealorama_StoreCartItem$.prototype = $p;
$p.aSz = (function(x$0) {
  var $x_2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$uJ(x$0.g(0));
  var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$uJ(x$0.g(1));
  return new $j_mealorama$002e$002dStore$002dCart$002dItem.$c_Lmealorama_StoreCartItem($x_2.l, $x_2.h, $x_1.l, $x_1.h, x$0.g(2), x$0.g(3), x$0.g(4), x$0.g(5), x$0.g(6), x$0.g(7), x$0.g(8));
});
var $d_Lmealorama_StoreCartItem$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_StoreCartItem$, "mealorama.StoreCartItem$", ({
  H3: 1,
  d: 1,
  e: 1
}));
export { $d_Lmealorama_StoreCartItem$ as $d_Lmealorama_StoreCartItem$ };
var $n_Lmealorama_StoreCartItem$;
function $m_Lmealorama_StoreCartItem$() {
  if ((!$n_Lmealorama_StoreCartItem$)) {
    $n_Lmealorama_StoreCartItem$ = new $c_Lmealorama_StoreCartItem$();
  }
  return $n_Lmealorama_StoreCartItem$;
}
export { $m_Lmealorama_StoreCartItem$ as $m_Lmealorama_StoreCartItem$ };
//# sourceMappingURL=mealorama.-Store-Cart-Item$.js.map
